import { useCallback } from 'react';

import {
  type LastInteractedStore,
  useLastInteractedStoreMachine,
} from '../../../../context';

// ─────────────────────────────────────────────────────────────────────────────

export const useSetProductDetailsLocation = () => {
  const [, send] = useLastInteractedStoreMachine();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const setLastInteractedMenuStore = useCallback(
    (store: LastInteractedStore) => {
      send({ type: 'SET_LAST_INTERACTED_MENU_STORE', store });
    },
    [send],
  );

  // ─────────────────────────────────────────────────────────────────────

  return {
    setLastInteractedMenuStore,
  };
};
